function DefaultLoader() {
    return <div class="lds-dual-ring-default"></div>
}

export default DefaultLoader;